import { createFileRoute, notFound, redirect } from '@tanstack/react-router'
import { meQuery, resolveWorkspace } from '@/lib/queries'

/** Settings live under a workspace now; this keeps older links working. */
export const Route = createFileRoute('/_app/settings/account')({
  beforeLoad: async ({ context }) => {
    const target = resolveWorkspace(await context.queryClient.ensureQueryData(meQuery))
    if (!target) throw notFound()
    throw redirect({ to: '/$org/settings/account', params: { org: target.slug }, replace: true })
  },
})
